import {
  GetCancelacionesProceso,
  GetCancelacionesIntentos,
  PostVerificarCancelacion,
  PostConfirmarCancelacion,
  PostReenviarSolicitudCancelacion
} from "../../reducers/notaCredito";
import * as actions from "../../actions/notaCredito";
import { Preview } from "../../../types/IAction";

export interface CancelacionesProcesoDispatcher {
  getCancelacionesByPeriodo: (
    periodo: string
  ) => Promise<Preview<GetCancelacionesProceso>>;
  getCancelacionesByFolio: (
    folioFactura: string
  ) => Promise<Preview<GetCancelacionesProceso>>;
  getCancelacionesIntentosByFactura: (
    idFactura: number
  ) => Promise<Preview<GetCancelacionesIntentos>>;
  postVerificarCancelacion: (
    uuid: string
  ) => Promise<Preview<PostVerificarCancelacion>>;
  postConfirmarCancelacion: (
    uuid: string
  ) => Promise<Preview<PostConfirmarCancelacion>>;
  postReenviarSolicitudCancelacion: (
    uuid: string
  ) => Promise<Preview<PostReenviarSolicitudCancelacion>>;
}

export const cancelacionesProcesoDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => CancelacionesProcesoDispatcher = dispatch => ({
  getCancelacionesByPeriodo: (periodo: string) => {
    return dispatch(actions.getCancelacionesByPeriodo(periodo));
  },
  getCancelacionesByFolio: (folioFactura: string) => {
    return dispatch(actions.getCancelacionesByFolio(folioFactura));
  },
  getCancelacionesIntentosByFactura: (idFactura: number) => {
    return dispatch(actions.getCancelacionesIntentosByFactura(idFactura));
  },
  postVerificarCancelacion: (uuid: string) => {
    return dispatch(actions.postVerificarCancelacion(uuid));
  },
  postConfirmarCancelacion: (uuid: string) => {
    return dispatch(actions.postConfirmarCancelacion(uuid));
  },
  postReenviarSolicitudCancelacion: (uuid: string) => {
    return dispatch(actions.postReenviarSolicitudCancelacion(uuid));
  }
});
